export default {
  pageTitle: '充值套餐',
  guide: '充值套餐面向企业使用者，用于在会员套餐额度之外单独补充 AI 修图、云存储空间、短信通知与名片数量等动态资源。每个资源类型包含多个套餐，额度用完可随时补购。',
  tabMine: '我的套餐',
  tabCatalog: '充值套餐',
  tabRecords: '充值记录',
  listed: '已上架',
  packageTiers: '{n} 档套餐档位',
  statTiers: '套餐档位',
  statTiersValue: '{n} 档',
  statMinPrice: '最低价',
  statMaxPrice: '最高价',
  validityRange: '{min}-{max} 天有效',
  validityDays: '{n}天有效',
  priceRange: '{min}--{max}',
  recharge: '充值',
  empty: '暂无可购买的充值套餐',
  unlimited: '不限量',
  masterExempt: '当前为系统内部超管公司，无需购买充值套餐',
  buySuccess: '充值已到账',
  payTitle: '充值支付',
  payNow: '立即支付 ¥{amount}',
  payMethod: '付款方式',
  payWechat: '微信支付',
  payAlipay: '支付宝',
  payTransfer: '对公转账',
  payScanTip: '请使用微信扫码完成支付',
  payNotice: '支付成功后额度实时到账。本充值包为会员套餐额度之外的资源扩充，不包含在会员权益内。如需发票请在付款后前往「订单记录」申请。',
  payFailed: '发起支付失败',
  payNoCodeUrl: '未获取到支付二维码',
  payCancelled: '订单已取消，请重新下单',
  payCancel: '取消',
  paySuccess: '支付成功',
  payCountdown: '剩余 {time}',
  mineTitle: '我的套餐',
  mineCount: '共 {n} 个已充值套餐',
  mineGuide: '以下是您在「充值套餐」中已购买并到账的资源包，可查看剩余额度与有效期。如需扩充，请前往「充值套餐」。',
  validUntilLabel: '有效期至',
  mineEmpty: '暂无可用充值套餐',
  orderNo: '订单',
  used: '已用',
  remaining: '剩余',
  validUntil: '有效期至 {date}',
  recordsTitle: '充值记录',
  recordsTotal: '累计充值 {amount}',
  recordsCardTitle: '我的充值记录',
  colOrderId: '订单号',
  colContent: '充值内容',
  colAmount: '金额',
  colPayMethod: '支付方式',
  colChargedAt: '充值时间',
  colStatus: '状态',
  colUserName: '用户名称',
  colVerification: '认证类别',
  verificationEnterprise: '组织认证',
  verificationPersonal: '个人认证',
  verificationNone: '未认证',
  adminRecordsCardTitle: '充值记录',
  payEnterpriseTransfer: '企业转账',
  payFree: '免费',
  statusPaid: '已到账',
  statusCancelled: '已取消',
  statusPending: '待支付'
}
